import Storage from '../../../common/services/storage';

export const NETWORK_CLEAR = 'network/CLEAR';

export default () => (dispatch) => {
  Storage.remove('currentNetwork');

  dispatch({ type: NETWORK_CLEAR });
};
